import { ConstructionsResponse, ConstructionElement } from "../../controllers/types";
import { API } from "../../controllers";
import { isNewSite } from "../../utils";
import { colorMapRuToEn } from "./enrichItemsWithNomenclature";
import { NewNomenkl } from "../../shared";

/**
 * Обогащает конструкции информацией о номенклатуре (nameNomenkl, nameNomenklAlt, priceNomenkl, priceAltNomenkl)
 * @param constructions - данные о конструкциях
 * @returns обогащенные данные о конструкциях
 */
export const enrichConstructionsWithNomenclature = async (
    constructions: ConstructionsResponse
): Promise<ConstructionsResponse> => {
    // Собираем все уникальные BITRIX_OFFER_ID и BITRIX_OFFER_ID_ALT из всех конструкций
    const allOfferIds = new Set<string>();
    const isNew = isNewSite();

    Object.values(constructions).forEach((section) => {
        section.ELEMENTS?.forEach((element) => {
            if (isNew) {
                if (element.BITRIX_OFFERS_IDS) {
                    element.BITRIX_OFFERS_IDS.forEach((id) => {
                        if (id) {
                            allOfferIds.add(id.toString());
                        }
                    });
                }
            }
            if (element.BITRIX_OFFER_ID) {
                allOfferIds.add(element.BITRIX_OFFER_ID.toString());
            }
            if (element.BITRIX_OFFER_ID_ALT) {
                allOfferIds.add(element.BITRIX_OFFER_ID_ALT.toString());
            }
        });
    });

    if (allOfferIds.size === 0) {
        return constructions;
    }

    try {
        // Получаем информацию о номенклатуре с сервера
        const { data: nomenclatureData } = await API.Configurator.getNomenclatureNamesByOfferIds(
            Array.from(allOfferIds)
        );

        // Обогащаем конструкции полученной информацией
        const enrichedConstructions: ConstructionsResponse = {};

        Object.keys(constructions).forEach((sectionKey) => {
            const section = constructions[sectionKey];
            enrichedConstructions[sectionKey] = {
                ...section,
                ELEMENTS: section.ELEMENTS?.map((element: ConstructionElement) => {
                    const newNomenkl = isNew
                        ? (element.BITRIX_OFFERS_IDS || [])
                              .map((id) => {
                                  const name = nomenclatureData[id]?.NAME || "";
                                  const price = nomenclatureData[id]?.PRICE || 0;
                                  const color =
                                      nomenclatureData[id]?.COLORS?.TSVET_KH_ELEMENTA_1 ||
                                      nomenclatureData[id]?.COLORS?.TSVET_KH_ELEMENTA;

                                  const shelfColor = nomenclatureData[id]?.COLORS?.TSVET_POLOK;
                                  const plankColor = nomenclatureData[id]?.COLORS?.TSVET_PLANOK;

                                  return id &&
                                      nomenclatureData[id] &&
                                      // @ts-ignore
                                      colorMapRuToEn[shelfColor] === "white" &&
                                      // @ts-ignore
                                      colorMapRuToEn[plankColor] === "silver"
                                      ? {
                                            bitrixId: id,
                                            nameNomenkl: name,
                                            priceNomenkl: price,
                                            color:
                                                // @ts-ignore
                                                colorMapRuToEn[color] ||
                                                // @ts-ignore
                                                (Object.entries(nomenclatureData[id]?.COLORS)?.find(
                                                    // @ts-ignore
                                                    ([key, value]) => colorMapRuToEn[value] === "white"
                                                )
                                                    ? "white"
                                                    : null),
                                        }
                                      : undefined;
                              })
                              .filter((nomenkl) => nomenkl && nomenkl?.color)
                        : [];

                    return {
                        ...element,
                        nameNomenkl: element.BITRIX_OFFER_ID
                            ? nomenclatureData[element.BITRIX_OFFER_ID]?.NAME
                            : undefined,
                        nameNomenklAlt: element.BITRIX_OFFER_ID_ALT
                            ? nomenclatureData[element.BITRIX_OFFER_ID_ALT]?.NAME
                            : undefined,
                        newNomenkl: newNomenkl as NewNomenkl[],
                        priceNomenkl: element.BITRIX_OFFER_ID
                            ? nomenclatureData[element.BITRIX_OFFER_ID]?.PRICE
                            : undefined,
                        priceAltNomenkl: element.BITRIX_OFFER_ID_ALT
                            ? nomenclatureData[element.BITRIX_OFFER_ID_ALT]?.PRICE
                            : undefined,
                        category: element.PROPERTIES.CATEGORY,
                        mounting: element.PROPERTIES.MOUNTING,
                        shelfType: element.PROPERTIES.SHELF_TYPE,
                        rackType: element.PROPERTIES.TYPE,
                    };
                }),
            };
        });

        return enrichedConstructions;
    } catch (error) {
        console.error("Ошибка при получении информации о номенклатуре для конструкций:", error);
        return constructions; // Возвращаем исходные данные в случае ошибки
    }
};
